import { render, staticRenderFns } from "./MultipleProductSummary.vue?vue&type=template&id=72964612&scoped=true"
import script from "./MultipleProductSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleProductSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MultipleProductSummary.vue?vue&type=style&index=0&id=72964612&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72964612",
  null
  
)

export default component.exports